<template>
  <div class="details-date text-grey text-size-xs text-left">
    {{ $getFormattedDate(details.transaction_date, "DD MMMM YYYY") }}
  </div>
  <PaymentCard :data="details" multiline />
  <div class="info-list text-size-xs">
    <div class="info-list__item">
      <div class="info-list__item_key">
        {{ details.operation_type === "OPER" ? $t`Дата и время` : $t`Дата` }}
      </div>
      <div class="info-list__item_value">
        {{
          $getFormattedDate(
            details.transaction_date,
            datePrintFormat,
            "YYYY-MM-DDTHH:mm:ss"
          )
        }}
      </div>
    </div>
    <template v-if="details.bonus_percent > 0">
      <Divider />
      <div class="info-list__item text-green">
        <div class="text-left">
          {{ $t`Начислен Бонус` }}
        </div>
        <div class="text-right font-bonus">
          + {{ $currencyFormatter(details.bonus_percent, "BONUS") }}
        </div>
      </div>
    </template>
  </div>
  <LinkButton
    v-if="isPaidWithQR && isReceiptVisible"
    :text="
      details.buying_status === 'Canceled'
        ? $t`Показать чек о возврате`
        : $t`Показать чек об оплате`
    "
    :height="64"
    @click="showReceipt"
  >
    <template #tail>
      <div class="i-arrow"></div>
    </template>
  </LinkButton>
  <LinkButton
    v-else-if="isShopPayment && isShopRedirectVisible"
    :text="$t`Детали заказа`"
    :height="64"
    @click="redirectToPurchaseDetails"
  >
    <template #tail>
      <div class="i-arrow"></div>
    </template>
  </LinkButton>
</template>

<script>
import PaymentCard from "@/components/dashboard/history/PaymentCard.vue";
import LinkButton from "@/components/shared/button/LinkButton.vue";
import Divider from "@/components/shared/divider/Divider.vue";
import { useStore } from "vuex";
import dayjs from "dayjs";

export default {
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  components: {
    PaymentCard,
    LinkButton,
    Divider,
  },
  setup(props) {
    const paymentDate = dayjs(props.details.transaction_date, "YYYY-MM-DD");
    const receiptShowDateStart = dayjs("2022-08-01", "YYYY-MM-DD");
    const shopDetailsShowDateStart = dayjs().subtract(6, "months");

    const isReceiptOutdated = paymentDate.isBefore(receiptShowDateStart);
    const isShopDetailsOutdated = paymentDate.isBefore(
      shopDetailsShowDateStart
    );

    const store = useStore();

    const datePrintFormat =
      props.details.operation_type === "OPER" ||
      props.details.transaction_type === "SHOP"
        ? "DD MMMM YYYY г. HH:mm"
        : "DD MMMM YYYY г.";

    function showReceipt() {
      if (window.mobapp?.navigate) {
        window.mobapp.navigate(
          `${process.env.VUE_APP_ENV_URL}/qr/receipt?extTranId=${props.details.transaction_id}`
        );
      }
    }

    function redirectToPurchaseDetails() {
      if (window.mobapp?.navigate) {
        window.mobapp.navigate(
          `${process.env.VUE_APP_ENV_URL}/shop/my-orders/${props.details.transaction_id}/`
        );
      }
    }

    return {
      isShopPayment: props.details.transaction_type === "SHOP",
      isShopRedirectVisible: !isShopDetailsOutdated,
      isPaidWithQR: props.details?.transaction_id.substring(0, 2) === "QR",
      isReceiptVisible:
        store.state.switchers.isPaymentCheckEnabled && !isReceiptOutdated,
      datePrintFormat,
      showReceipt,
      redirectToPurchaseDetails,
    };
  },
};
</script>

<style lang="scss" scoped>
.details-date {
  padding: 13px;
}

.link-btn {
  margin-top: 1px;
}

.info-list {
  background-color: #fff;
  padding: 0 15px 15px 68px;
  position: relative;

  &__item {
    border-top: 1px solid #eeeeee;
    padding: 8px 0;
    display: flex;
    justify-content: space-between;
  }
}

.product-btn {
  margin-top: 1px;
}
</style>
